/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jun 22 2023
 **/

import { useEffect, useRef, useState } from "react";

// import { useDragging } from "@/frameworks/core/hooks";

import { popoverCSS } from "./emotion";

type Coordinate = {
	x: number;
	y: number;
	width: number;
	height: number;
};

interface PopoverWrapperProps {
	children: React.ReactNode;
	direction?: {
		x: "center" | "left" | "right";
		y: "center" | "bottom" | "top";
	};
	position?: {
		x: number;
		y: number;
	};
	anchorPosition: Coordinate;
	zIndex: number;
	overflow?: boolean;
	hasMouseClickAction?: boolean;
}

export default function PopoverWrapper({
	children,
	direction,
	position,
	anchorPosition,
	zIndex,
	overflow = false,
	hasMouseClickAction = false
}: PopoverWrapperProps) {
	const popoverRef = useRef<HTMLDivElement>(null);
	const [popoverPosition, setPopoverPosition] = useState<Coordinate | null>(null);

	useEffect(() => {
		if (!popoverRef.current) return;
		const _position = position ? { ...position, width: 0, height: 0 } : { x: 0, y: 0, width: 0, height: 0 };
		_position.width = popoverRef.current?.clientWidth ?? 0;
		_position.height = popoverRef.current?.clientHeight ?? 0;
		setPopoverPosition(_position);
	}, []);

	return (
		<div
			tabIndex={0}
			autoFocus
			css={popoverCSS({
				direction,
				position: popoverPosition,
				anchorPosition,
				overflow,
				hasMouseClickAction,
				zIndex
			})}
			ref={popoverRef}
		>
			{children}
		</div>
	);
}
